import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from 'src/app/core/services/user.services';
import { DialogCashComponent } from './dialog-cash/dialog-cash.component';
import { NotificationService } from 'src/app/core/services/notification.service';
import { ComisionesService } from 'src/app/core/services/comisiones.service';

@Component({
  selector: 'app-withdraw-cash',
  templateUrl: './withdraw-cash.component.html',
  styleUrls: ['./withdraw-cash.component.scss']
})
export class WithdrawCashComponent implements OnInit {
  @ViewChild('rapipagoIdInput') rapipagoIdInput: ElementRef;

  codeBar: string;
  showCode: boolean = false;
  accountBalance: number = 0;
  disabledRapipago: boolean = false;
  private gettingTransactionId: boolean = false;
  fileDialogCashOut: MatDialogRef<DialogCashComponent>;
  cashOut;
  porcentajeComision: number;
  maxCashin: number;
  minCashin: number;
  disponibleCash: number;

  constructor(
    private notificationService: NotificationService,
    private userService: UserService,
    private router: Router,
    private dialog: MatDialog,
    private ComisionesService: ComisionesService
  ) {}

  async ngOnInit() {
    this.cashOut = (await this.ComisionesService.getCashOut()).object;
    this.disponibleCash = await this.userService.rapipagoCashOut();
    this.porcentajeComision = this.cashOut.porcentaje;
    this.maxCashin = this.cashOut.max;
    this.minCashin = this.cashOut.min;
  }

  async isCodeBar() {
    this.codeBar != '' ? true : false;
  }

  async showCodeBar() {
    if (!this.showCode) {
      this.codeBar = await this.userService.getRapipagoTxId();
      this.showCode = true;
    } else {
      this.showCode = false;
    }
  }

  navigate(url: string) {
    this.router.navigate([url]);
  }

  copyCodeBar() {
    if (this.showCode) {
      this.rapipagoIdInput.nativeElement.select();
      document.execCommand('copy');
      this.rapipagoIdInput.nativeElement.setSelectionRange(0, 0);
      this.notificationService.showSuccess('Codigo de barra copiado en el portapapeles');
    }
  }

  get porcentajeCom(): number {
    return this.porcentajeComision;
  }

  get maxCash(): number {
    return this.maxCashin;
  }

  get minCash(): number {
    return this.minCashin;
  }

  get dispCash(): number {
    return this.disponibleCash;
  }
}
